import { FC, useEffect } from "react";
import { useSelector } from "react-redux";

import { ISettingOptions } from "../../../types/interfaces";

import styles from "../headerBtn.module.scss";

const CustomerReportsSettingsSection: FC<ISettingOptions> = ({
  setSelectedSettings,
  selectedSettings,
  setIsCheckedFullInfo,
  isCheckedFullInfo,
}) => {
  const { data } = useSelector(
    (state: any) => state.user.user
  );
  
  const options = [
    { value: "reportId", label: "№ отчета" },
    { value: "date", label: "Дата" },
    { value: "region", label: "Регион" },
    { value: "chain", label: "Сеть" },
    { value: "address", label: "Адрес" },
    { value: "rate", label: "Оценка" },
    data &&
      data.settings?.showReportCheckTypes && {
        value: "checkTypes",
        label: "Тип проверки",
      },
    { value: "fixDate", label: "Дата исправления" },
    data &&
      data.settings?.reviewStatus && { value: "review", label: "Проверка" },
    data &&
    data.settings?.contracts.length > 0 && {
        value: "contract",
        label: "Контракт",
      },
    { value: "project", label: "Проект" },
    { value: "sv", label: "Супервайзер" },
    { value: "merchRoutes", label: "Мерчендайзер" },
    { value: "responsible", label: "Ответственный" },
    { value: "clientId", label: "ID ТТ клиента" },
  ].filter(Boolean);

  const handleChangeCheckbox = (name: string) => {
    if (selectedSettings.includes(name)) {
      const updatedSettings = selectedSettings.filter(
        (elem: string) => elem !== name
      );

      setSelectedSettings(updatedSettings);
      setIsCheckedFullInfo(false);
    } else {
      const updatedSettings = [...selectedSettings, name];

      setSelectedSettings(updatedSettings);
      setIsCheckedFullInfo(updatedSettings.length === options.length);
    }
  };

  const handleChangeFullInfoCheckbox = () => {
    if (!isCheckedFullInfo) {
      setSelectedSettings([
        "reportId",
        "date",
        "region",
        "chain",
        "address",
        "rate",
        "checkTypes",
        "fixDate",
        "review",
        "contract",
        "project",
        "sv",
        "merchRoutes",
        "responsible",
        "clientId",
      ]);
    } else {
      setSelectedSettings([]);
    }
    setIsCheckedFullInfo(!isCheckedFullInfo);
  };

  useEffect(()=>{
    setIsCheckedFullInfo(selectedSettings.length === options.length);
    // eslint-disable-next-line
  },[]);

  return (
    <div className={styles.settings__block_info}>
      <div className={styles.check__list_block}>
        {options
          ?.filter((option: {value: string, label: string}) => option)
          .map((option) => (
            <div key={option.value} className={styles.check__list_elem}>
              <label className={styles.checkbox__container}>
                <input
                  checked={selectedSettings.includes(option.value)}
                  type="checkbox"
                  onChange={() => handleChangeCheckbox(option.value)}
                />
                <span className={styles.multi__reason_checkmark}></span>
              </label>
              {option.label}
            </div>
          ))}
        <div className={styles.check__list_elem}>
          <label className={styles.checkbox__container}>
            <input
              type={"checkbox"}
              onChange={handleChangeFullInfoCheckbox}
              checked={isCheckedFullInfo}
            />
            <span className={styles.multi__reason_checkmark}></span>
          </label>
          Все
        </div>
      </div>
    </div>
  );
};

export default CustomerReportsSettingsSection;
